.backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.backdrop[data-open="true"] {
  opacity: 1;
}

.sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: 70vh;
  background-color: #ffffff;
  border-radius: 12px 12px 0 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  transform: translateY(100%);
  transition: transform 0.3s cubic-bezier(0.32, 0.72, 0, 1);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.sheet[data-open="true"] {
  transform: translateY(0);
}

.handleArea {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0 8px;
  cursor: grab;
  flex-shrink: 0;
  touch-action: none;
}

.handleBar {
  width: 36px;
  height: 4px;
  background-color: #d1d5db;
  border-radius: 2px;
}

.sheetContent {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  min-height: 0;
  padding: 0 16px 16px;
}

/* Override fixed widths from popout Menu component inside the sheet */
.sheetContent > div {
  width: 100%;
}

/* Ensure popout action items have proper touch targets in the bottom sheet */
.sheetContent li {
  min-height: var(--mobile-touch-target);
}
